import * as React from 'react';
import {ApplicationState} from "../store";
import {
	Collapse,
	Divider,
	Drawer,
	IconButton,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	ListSubheader,
	withStyles
} from "@material-ui/core";
import {Tab, TabTypes} from "../tabs/Tab";
import classNames from "classnames";
import {actionShrinkMainMenu} from "../store/global";
import PeopleIcon from '@material-ui/icons/People';
import BarChartIcon from '@material-ui/icons/BarChart';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import AddIcon from "@material-ui/icons/AddCircleOutlineRounded";
import ListIcon from '@material-ui/icons/List';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import SecurityIcon from '@material-ui/icons/Security';
import CategoryIcon from '@material-ui/icons/Category';
import SettingsIcon from '@material-ui/icons/Settings';
import ApartmentIcon from '@material-ui/icons/Apartment';
import NotificationsIcon from '@material-ui/icons/Notifications';
import AssignmentIcon from '@material-ui/icons/Assignment';
import {Customer} from '../models/Customer';
import {Service} from '../models/Service';
import {Category} from '../models/Category';
import {Permissions} from "../core/auth/Permissions";
import PermissionContainer from "../core/auth/PermissionContainer";
import {BaseModel} from "../models/BaseModel";
import {TabsService} from "../tabs/TabsService";
import {connect} from "react-redux";
import {GlobalStyles} from "../materialui/style";
import {compose} from "redux";
import {Contract} from "../models/Contract";
import {Payment} from '../models/Payment';
import {Invoice} from "../models/Invoice";
import {t} from '../core/localization';
import {Document, DocumentTypes} from "../models/Document";
import {Department} from "../models/Department";
import {Position} from "../models/Position";
import {Employee} from "../models/Employee";
import {Notification} from "../models/Notification";
import {Dashboard, FindInPageRounded, LocalLibrary, PlaylistAdd} from "@material-ui/icons";
import {actionDocumentIndexingNumberRequest} from "../store/documents";
import {AppConfig} from "../config";

export interface MainMenuProps {
	activeTab: Tab
	mainMenuExtended: boolean,
	classes: any
	indexingNumber: string
}

export interface MainMenuState {
	customersOpen: boolean
	servicesOpen: boolean
	categoriesOpen: boolean
	contractsOpen: boolean
	financesOpen: boolean
	reportsOpen: boolean
	documentsOpen: boolean
	structuresOpen: boolean
	notificationsOpen: boolean
}

function mapStateToProps(state: ApplicationState) {
	return {
		activeTab: state.tabs.active,
		mainMenuExtended: state.global.mainMenuOpened,
		indexingNumber: state.documents.indexingNumber
	};
}

class MainMenu extends React.Component<MainMenuProps, MainMenuState> {

	constructor(props: MainMenuProps) {
		super(props)
		this.state = {
			customersOpen: false,
			servicesOpen: false,
			categoriesOpen: false,
			contractsOpen: false,
			financesOpen: false,
			reportsOpen: false,
			documentsOpen: false,
			structuresOpen: false,
			notificationsOpen: false
		}
	}

	componentDidMount() {
		actionDocumentIndexingNumberRequest()
	}

	render(): React.ReactNode {

		let classes = this.props.classes

		return (
			<Drawer
				variant="permanent"
				classes={{
					paper: classNames(classes.drawerPaper, !this.props.mainMenuExtended && classes.drawerPaperClose),
				}}
				open={this.props.mainMenuExtended}
			>
				<div className={'ev-logo'}></div>
				<div className={classes.toolbarIcon}>
					<IconButton onClick={this.handleDrawerClose}>
						<ChevronLeftIcon />
					</IconButton>
				</div>
				<Divider />
				{this.getMainFirstListItems()}

				{this.getMainThirdListItems()}
			</Drawer>
		);
	}


	private getMainFirstListItems (): React.ReactNode {
		let open = true
		return (
			<List>
				<ListSubheader>{t.Menu1Title}</ListSubheader>
				<ListItem button onClick={() => {this.openNewTab(TabTypes.DASHBOARD)}}>
					<ListItemIcon>
						<Dashboard/>
					</ListItemIcon>
					<ListItemText primary={'Dashboard'}/>
				</ListItem>
				<PermissionContainer hasAnyPermission={[Permissions.CUSTOMERS_EDIT, Permissions.CUSTOMERS_READ]} >
					<ListItem button onClick={() => {this.setState({...this.state, customersOpen: !this.state.customersOpen})}}>
						<ListItemIcon>
							<PeopleIcon />
						</ListItemIcon>
						<ListItemText primary={t.Customers} />
						{this.state.customersOpen ? <ExpandLess /> : <ExpandMore />}
					</ListItem>
					<Collapse in={this.state.customersOpen} timeout="auto" unmountOnExit>
						<List disablePadding>
							<ListItem button onClick={() => {this.openNewTab(TabTypes.CUSTOMERS)}}>
								<ListItemIcon>
									<ListIcon />
								</ListItemIcon>
								<ListItemText primary={t.CustomersList} />
							</ListItem>
							<PermissionContainer hasPermission={Permissions.CUSTOMERS_EDIT} >
								<ListItem button onClick={() => {this.openNewTab(TabTypes.CUSTOMERS_NEW, new Customer())}}>
									<ListItemIcon>
										<AddIcon />
									</ListItemIcon>
									<ListItemText primary={t.AddCustomer} />
								</ListItem>
							</PermissionContainer>
						</List>
					</Collapse>
					<Divider />
				</PermissionContainer>
				{!AppConfig().appearance.hideServices && <PermissionContainer hasAnyPermission={[Permissions.SERVICES_EDIT, Permissions.SERVICES_READ]} >
					<ListItem button onClick={() => {this.setState({...this.state, categoriesOpen: !this.state.categoriesOpen})}}>
						<ListItemIcon>
							<CategoryIcon />
						</ListItemIcon>
						<ListItemText primary={t.Categories} />
						{this.state.categoriesOpen ? <ExpandLess /> : <ExpandMore />}
					</ListItem>
					<Collapse in={this.state.categoriesOpen} timeout="auto" unmountOnExit>
						<List disablePadding>
							<ListItem button onClick={() => {this.openNewTab(TabTypes.CATEGORIES)}}>
								<ListItemIcon>
									<ListIcon />
								</ListItemIcon>
								<ListItemText primary={t.CategoriesList} />
							</ListItem>
							<PermissionContainer hasPermission={Permissions.SERVICES_EDIT} >
								<ListItem button onClick={() => {this.openNewTab(TabTypes.CATEGORIES_NEW, new Category())}}>
									<ListItemIcon>
										<AddIcon />
									</ListItemIcon>
									<ListItemText primary={t.AddCategory} />
								</ListItem>
							</PermissionContainer>
						</List>
					</Collapse>
					<Divider />
				</PermissionContainer>}
				{!AppConfig().appearance.hideServices && <PermissionContainer hasAnyPermission={[Permissions.SERVICES_EDIT, Permissions.SERVICES_READ]} >
					<ListItem button onClick={() => {this.setState({...this.state, servicesOpen: !this.state.servicesOpen})}}>
						<ListItemIcon>
							<ShoppingBasketIcon />
						</ListItemIcon>
						<ListItemText primary={t.Services} />
						{this.state.servicesOpen ? <ExpandLess /> : <ExpandMore />}
					</ListItem>
					<Collapse in={this.state.servicesOpen} timeout="auto" unmountOnExit>
						<List disablePadding>
							<ListItem button onClick={() => {this.openNewTab(TabTypes.SERVICES)}}>
								<ListItemIcon>
									<ListIcon />
								</ListItemIcon>
								<ListItemText primary={t.ServicesList} />
							</ListItem>
							<PermissionContainer hasPermission={Permissions.SERVICES_EDIT} >
								<ListItem button onClick={() => {this.openNewTab(TabTypes.SERVICES_NEW, new Service())}}>
									<ListItemIcon>
										<AddIcon />
									</ListItemIcon>
									<ListItemText primary={t.AddService} />
								</ListItem>
							</PermissionContainer>
						</List>
					</Collapse>
					<Divider />
				</PermissionContainer>}
				{!AppConfig().appearance.hideContracts && <PermissionContainer hasAnyPermission={[Permissions.CONTRACTS_EDIT, Permissions.CONTRACTS_READ]} >
					<ListItem button onClick={() => {this.setState({...this.state, contractsOpen: !this.state.contractsOpen})}}>
						<ListItemIcon>
							<BusinessCenterIcon />
						</ListItemIcon>
						<ListItemText primary={t.Contracts} />
						{this.state.contractsOpen ? <ExpandLess /> : <ExpandMore />}
					</ListItem>
					<Collapse in={this.state.contractsOpen} timeout="auto" unmountOnExit>
						<List disablePadding>
							<ListItem button onClick={() => {this.openNewTab(TabTypes.CONTRACTS)}}>
								<ListItemIcon>
									<ListIcon />
								</ListItemIcon>
								<ListItemText primary={t.ContractsList} />
							</ListItem>
							<PermissionContainer hasPermission={Permissions.CONTRACTS_EDIT} >
								<ListItem button onClick={() => {this.openNewTab(TabTypes.CONTRACTS_NEW, new Contract())}}>
									<ListItemIcon>
										<AddIcon />
									</ListItemIcon>
									<ListItemText primary={t.AddContract} />
								</ListItem>
							</PermissionContainer>
						</List>
					</Collapse>
					<Divider />
				</PermissionContainer>}
				{!AppConfig().appearance.hideFinances && <PermissionContainer hasAnyPermission={[Permissions.INVOICES_EDIT, Permissions.INVOICES_READ, Permissions.PAYMENTS_EDIT, Permissions.PAYMENTS_READ]} >
					<ListItem button onClick={() => {this.setState({...this.state, financesOpen: !this.state.financesOpen})}}>
						<ListItemIcon>
							<AccountBalanceIcon />
						</ListItemIcon>
						<ListItemText primary={t.Finances} />
						{this.state.financesOpen ? <ExpandLess /> : <ExpandMore />}
					</ListItem>
					<Collapse in={this.state.financesOpen} timeout="auto" unmountOnExit>
						<List disablePadding>
							<ListItem button onClick={() => {this.openNewTab(TabTypes.INVOICES)}}>
								<ListItemIcon>
									<ListIcon />
								</ListItemIcon>
								<ListItemText primary={t.InvoiceList} />
							</ListItem>
							<PermissionContainer hasPermission={Permissions.INVOICES_EDIT} >
								<ListItem button onClick={() => {this.openNewTab(TabTypes.INVOICES_NEW, new Invoice())}}>
									<ListItemIcon>
										<AddIcon />
									</ListItemIcon>
									<ListItemText primary={t.AddInvoice} />
								</ListItem>
							</PermissionContainer>
						</List>
						<List disablePadding>
							<ListItem button onClick={() => {this.openNewTab(TabTypes.PAYMENTS)}}>
								<ListItemIcon>
									<ListIcon />
								</ListItemIcon>
								<ListItemText primary={t.PaymentList} />
							</ListItem>
							<PermissionContainer hasPermission={Permissions.PAYMENTS_EDIT} >
								<ListItem button onClick={() => {this.openNewTab(TabTypes.PAYMENTS_NEW, new Payment())}}>
									<ListItemIcon>
										<AddIcon />
									</ListItemIcon>
									<ListItemText primary={t.AddPayment} />
								</ListItem>
							</PermissionContainer>
						</List>
					</Collapse>
					<Divider />
				</PermissionContainer>}
				{!AppConfig().appearance.hideReports && <PermissionContainer hasAnyPermission={[Permissions.REPORTS_READ]} >
					<ListItem button onClick={() => {this.setState({...this.state, reportsOpen: !this.state.reportsOpen})}}>
						<ListItemIcon>
							<BarChartIcon />
						</ListItemIcon>
						<ListItemText primary={t.Reports} />
						{this.state.reportsOpen ? <ExpandLess /> : <ExpandMore />}
					</ListItem>
					<Collapse in={this.state.reportsOpen} timeout="auto" unmountOnExit>
						<List disablePadding>
							<ListItem button onClick={() => {this.openNewTab(TabTypes.REPORT_INVOICES_PAYMENTS)}}>
								<ListItemIcon>
									<ListIcon />
								</ListItemIcon>
								<ListItemText primary={t.InvoicesPayments} />
							</ListItem>
						</List>
						<List disablePadding>
							<ListItem button onClick={() => {this.openNewTab(TabTypes.REPORT_SERVICES)}}>
								<ListItemIcon>
									<ListIcon />
								</ListItemIcon>
								<ListItemText primary={t.ServicesReport} />
							</ListItem>
						</List>
					</Collapse>
					<Divider />
				</PermissionContainer>}
				<PermissionContainer hasAnyPermission={[Permissions.DOCUMENTS_READ, Permissions.DOCUMENTS_EDIT]} >
					<ListItem button onClick={() => {this.setState({...this.state, documentsOpen: !this.state.documentsOpen})}}>
						<ListItemIcon>
							<LocalLibrary />
						</ListItemIcon>
						<ListItemText primary={t.Documents} />
						{this.state.documentsOpen ? <ExpandLess /> : <ExpandMore />}
					</ListItem>
					<Collapse in={this.state.documentsOpen} timeout="auto" unmountOnExit>
						<List disablePadding>
							<ListItem button onClick={() => {this.openNewTab(TabTypes.DOCUMENTS_SEARCH)}}>
								<ListItemIcon>
									<FindInPageRounded />
								</ListItemIcon>
								<ListItemText primary={t.DocumentsSearch} />
							</ListItem>
						</List>
						<PermissionContainer hasAllPermissions={[Permissions.DOCUMENTS_READ, Permissions.DOCUMENTS_STRUCTURE]} >
							<List disablePadding>
								<ListItem button onClick={() => {this.openNewTab(TabTypes.DOCUMENTS)}}>
									<ListItemIcon>
										<ListIcon />
									</ListItemIcon>
									<ListItemText primary={t.DocumentsView} />
								</ListItem>
							</List>
						</PermissionContainer>
						<PermissionContainer hasAnyPermission={[Permissions.DOCUMENTS_EDIT]} >
							<List disablePadding>
								<ListItem button onClick={() => {this.openNewTab(TabTypes.DOCUMENTS_INDEXING)}}>
									<ListItemIcon>
										<PlaylistAdd />
									</ListItemIcon>
									<ListItemText primary={t.DocumentsIndexing} />
								</ListItem>
							</List>
						</PermissionContainer>
						<PermissionContainer hasAnyPermission={[Permissions.DOCUMENTS_EDIT]} >
							<List disablePadding>
								<ListItem button onClick={() => {
									const newDoc = new Document()
									newDoc.type = DocumentTypes.Undefined
									// newDoc.indexingNumber = this.props.indexingNumber
									// newDoc.fields = {}
									// newDoc.fields.indexingNumber = this.props.indexingNumber
									this.openNewTab(TabTypes.DOCUMENT_NEW, newDoc)}}
								>
									<ListItemIcon>
										<AddIcon />
									</ListItemIcon>
									<ListItemText primary={t.NewDocument} />
								</ListItem>
							</List>
						</PermissionContainer>
					</Collapse>
					<Divider />
				</PermissionContainer>
				<PermissionContainer hasAnyPermission={[Permissions.COMPANY_STRUCTURE_EDIT, Permissions.COMPANY_STRUCTURE_READ]} >
					<ListItem button onClick={() => {this.setState({...this.state, structuresOpen: !this.state.structuresOpen})}}>
						<ListItemIcon>
							<ApartmentIcon/>
						</ListItemIcon>
						<ListItemText primary={t.CompanyStructure} />
						{this.state.structuresOpen ? <ExpandLess /> : <ExpandMore />}
					</ListItem>
					<Collapse in={this.state.structuresOpen} timeout="auto" unmountOnExit>
						<List disablePadding>
							<ListItem button onClick={() => {this.openNewTab(TabTypes.DEPARTMENTS)}}>
								<ListItemIcon>
									<ListIcon />
								</ListItemIcon>
								<ListItemText primary={t.DepartmentList} />
							</ListItem>
							<PermissionContainer hasPermission={Permissions.COMPANY_STRUCTURE_EDIT} >
								<ListItem button onClick={() => {this.openNewTab(TabTypes.DEPARTMENTS_NEW, new Department())}}>
									<ListItemIcon>
										<AddIcon />
									</ListItemIcon>
									<ListItemText primary={t.NewDepartment} />
								</ListItem>
							</PermissionContainer>
						</List>
						<List disablePadding>
							<ListItem button onClick={() => {this.openNewTab(TabTypes.POSITIONS)}}>
								<ListItemIcon>
									<ListIcon />
								</ListItemIcon>
								<ListItemText primary={t.PositionList} />
							</ListItem>
							<PermissionContainer hasPermission={Permissions.COMPANY_STRUCTURE_EDIT} >
								<ListItem button onClick={() => {this.openNewTab(TabTypes.POSITIONS_NEW, new Position())}}>
									<ListItemIcon>
										<AddIcon />
									</ListItemIcon>
									<ListItemText primary={t.NewPosition} />
								</ListItem>
							</PermissionContainer>
						</List>
						<List disablePadding>
							<ListItem button onClick={() => {this.openNewTab(TabTypes.EMPLOYEES)}}>
								<ListItemIcon>
									<ListIcon />
								</ListItemIcon>
								<ListItemText primary={t.EmployeesList} />
							</ListItem>
							<PermissionContainer hasPermission={Permissions.COMPANY_STRUCTURE_EDIT} >
								<ListItem button onClick={() => {this.openNewTab(TabTypes.EMPLOYEES_NEW, new Employee())}}>
									<ListItemIcon>
										<AddIcon />
									</ListItemIcon>
									<ListItemText primary={t.NewEmployee} />
								</ListItem>
							</PermissionContainer>
						</List>
					</Collapse>
					<Divider />
				</PermissionContainer>
				<PermissionContainer hasAnyPermission={[Permissions.NOTIFICATION_EDIT, Permissions.NOTIFICATION_READ]} >
					<ListItem button onClick={() => {this.setState({...this.state, notificationsOpen: !this.state.notificationsOpen})}}>
						<ListItemIcon>
							<NotificationsIcon />
						</ListItemIcon>
						<ListItemText primary={t.Notifications} />
						{this.state.notificationsOpen ? <ExpandLess /> : <ExpandMore />}
					</ListItem>
					<Collapse in={this.state.notificationsOpen} timeout="auto" unmountOnExit>
						<List disablePadding>
							<ListItem button onClick={() => {this.openNewTab(TabTypes.NOTIFICATIONS)}}>
								<ListItemIcon>
									<ListIcon />
								</ListItemIcon>
								<ListItemText primary={t.NotificationList} />
							</ListItem>
							<PermissionContainer hasPermission={Permissions.NOTIFICATION_EDIT} >
								<ListItem button onClick={() => {this.openNewTab(TabTypes.NOTIFICATIONS_NEW, new Notification())}}>
									<ListItemIcon>
										<AddIcon />
									</ListItemIcon>
									<ListItemText primary={t.NewNotification} />
								</ListItem>
							</PermissionContainer>
						</List>
					</Collapse>
					<Divider />
				</PermissionContainer>
			</List>
		);
	}

	private getMainThirdListItems (): React.ReactNode {
		return (<PermissionContainer hasAnyPermission={[Permissions.USERS_EDIT, Permissions.USERS_READ, Permissions.TENANT_WRITE, Permissions.TENANT_READ]} ><List>
			<ListSubheader>{t.Menu2Title}</ListSubheader>
			<PermissionContainer hasAnyPermission={[Permissions.USERS_EDIT, Permissions.USERS_READ]} >
				<ListItem button onClick={() => {this.openNewTab(TabTypes.USERS)}}>
					<ListItemIcon>
						<SecurityIcon/>
					</ListItemIcon>
					<ListItemText primary={t.Users}/>
				</ListItem>
			</PermissionContainer>
			<PermissionContainer hasAnyPermission={[Permissions.ROLES_EDIT, Permissions.ROLES_READ]} >
				<ListItem button onClick={() => {this.openNewTab(TabTypes.ROLES)}}>
					<ListItemIcon>
						<AssignmentIcon/>
					</ListItemIcon>
					<ListItemText primary={t.Roles}/>
				</ListItem>
			</PermissionContainer>
			<PermissionContainer hasAnyPermission={[Permissions.TENANT_WRITE, Permissions.TENANT_READ]} >
				<ListItem button onClick={() => {this.openNewTab(TabTypes.TENANT)}}>
					<ListItemIcon>
						<SettingsIcon/>
					</ListItemIcon>
					<ListItemText primary={t.Settings}/>
				</ListItem>
			</PermissionContainer>
		</List></PermissionContainer>)
	}

	private openNewTab(type: TabTypes, item?: BaseModel) {
		//console.log(type)
		TabsService.createTab(type.defaultTitle(), type, item)
	}

	private handleDrawerClose = () => {
		actionShrinkMainMenu()
	}
}

export default compose(
	connect(mapStateToProps),
	withStyles(GlobalStyles)
)(MainMenu)



